import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class DataAccess {

  private eptArticleNo = new BehaviorSubject<string>('NoArticle'); // Initial value
  public getEptArticleNo = this.eptArticleNo.asObservable(); // Observable to expose

  constructor() { }

  setEptArticleNo(_articleNo: string) {
    this.eptArticleNo.next(_articleNo);
  }


}
